import { Pagination, PaginationModel } from '@isbj-redesign/shared-components'
import React, { useCallback, useMemo } from 'react'

export type TablePaginationProps = {
    offset: number
    limit: number
    total: number
    onPagination(offset: number, limit: number): void
}

const info = '%startItemIndex%-%endItemIndex% von %totalItems% gefundenen Datensätzen.'

export function TablePagination({ offset, limit, total, onPagination }: TablePaginationProps) {
    const model = useMemo(() => new PaginationModel(offset, total, limit), [offset, total, limit])
    const onPageChange = useCallback((page: number) => onPagination(Math.max(page * limit, 0), limit), [onPagination, limit])
    return <Pagination infoText={info} model={model} navigationListener={onPageChange} />
}
